import { _request } from './request';

export type VowsAnalysisType = {
  tone: {
    couple1: string;
    couple2: string;
  };
  length: {
    couple1: number;
    couple2: number;
    suggestion: string;
  };
  suggestions: {
    partner1: string[];
    partner2: string[];
  };
};

export type VowsAnalysisResponse = {
  success: boolean;
  data: {
    id: number;
    member_one_id: number;
    member_two_id: number;
    ceremony_id: number;
    vows_analysis: VowsAnalysisType;
    created_at: string;
    updated_at: string;
    memberOne: {
      id: number;
      legal_name: string;
    };
    memberTwo: {
      id: number;
      legal_name: string;
    };
  };
};

export const getVowsAnalysis = async ({
  ceremonyId,
}: {
  ceremonyId: string;
}) => {
  const params = {
    ceremony_id: ceremonyId,
  };

  const searchParams = new URLSearchParams({
    ceremony_id: ceremonyId,
  });

  const responseBody = await _request<VowsAnalysisResponse>({
    url: `vows_analysis?${searchParams.toString()}`,
    method: 'GET',
  });
  return responseBody;
};
